import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { AppBreadcrumb } from './common';
import { FirmCreatePage, FirmDetailsPage, FirmsListPage } from './pages';

// Wrapper component for firm details page with breadcrumb
const FirmDetailsWrapper = () => {
  return (
    <>
      <AppBreadcrumb />
      <FirmDetailsPage />
    </>
  );
};

/**
 * FirmLayout component that renders the firm-related routes
 * No longer needs FirmProvider as we're using useCurrentFirm hook directly in components
 */
export const FirmsLayout: React.FC = () => {
  return (
    <div className="mx-6 flex flex-col">
      <Routes>
        {/* Main firm routes */}
        <Route
          index
          element={
            <>
              <AppBreadcrumb />
              <FirmsListPage />
            </>
          }
        />
        <Route
          path="create"
          element={
            <>
              <AppBreadcrumb />
              <FirmCreatePage />
            </>
          }
        />

        {/* Firm details and nested routes */}
        <Route path=":firm_id/*" element={<FirmDetailsWrapper />} />

        {/* Fallback route */}
        <Route path="*" element={<Navigate to="/firms" />} />
      </Routes>
    </div>
  );
};
